var map = {
	"./st0.png": "98fd",
	"./st1.png": "3e01",
	"./st10.png": "f999",
	"./st20.png": "1591",
	"./st30.png": "f18f",
	"./st40.png": "5b3c",
	"./star1-new.png": "d182",
	"./star1.png": "a65c",
	"./star2-new.png": "f0bb",
	"./star2.png": "1b2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "238a";